/**
 * Layout route for the reports section (/_app/reports).
 *
 * Intentionally minimal — just an <Outlet /> so child routes can render
 * (the reports hub lives at reports/index.tsx, individual report pages
 * like reports/dealer-statement.tsx, reports/supplier-balances.tsx, etc.
 * render inside this shell).
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reports")({
  component: ReportsLayout,
});

function ReportsLayout() {
  return <Outlet />;
}
